import { render, staticRenderFns } from "./StoriesLine.vue?vue&type=template&id=153528b1&scoped=true&"
import script from "./StoriesLine.vue?vue&type=script&lang=ts&"
export * from "./StoriesLine.vue?vue&type=script&lang=ts&"
import style0 from "./StoriesLine.vue?vue&type=style&index=0&id=153528b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153528b1",
  null
  
)

export default component.exports